export default "__VITE_ASSET__aVALQJyr__"